import { render, staticRenderFns } from "./67.vue?vue&type=template&id=36a2c71c&scoped=true&"
var script = {}
import style0 from "./67.vue?vue&type=style&index=0&id=36a2c71c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a2c71c",
  null
  
)

export default component.exports